module.exports = __webpack_public_path__ + "static/media/info-light.cdb31d30.svg";